import BaseClass from "../BaseClass";
import moment from "moment";

export default class Period extends BaseClass {
  constructor(...args) {
    super(...args);
    // let _this = this;
    // Object.defineProperty(this, "asString", {
    //     get: function () {
    //         return _this.date_start + " — " + _this.date_end;
    //     },
    //     configurable: true
    // })
  }
  get asString() {
    return this.date_start + " — " + this.date_end;
  }

  get start() {
    return moment(this.date_start, "DD-MM-YYYY");
  }

  get end() {
    return moment(this.date_end, "DD-MM-YYYY");
  }

  get hasWrongDateFormat() {
    return (
      !/(\d{2})-(\d{2})-(\d{4})/.test(this.date_start) ||
      !/(\d{2})-(\d{2})-(\d{4})/.test(this.date_end)
    );
  }

  fixDateFormat() {
    /(\d{2})-(\d{2})-(\d{4})/.test(this.date_start) ||
      (this.date_start = this.date_start
        .split("-")
        .reverse()
        .join("-"));
    /(\d{2})-(\d{2})-(\d{4})/.test(this.date_end) ||
      (this.date_end = this.date_end
        .split("-")
        .reverse()
        .join("-"));
  }

  dateHaveCrossWith(date) {
    return (
      date.start.isBetween(this.start, this.end, null, "[]") ||
      date.end.isBetween(this.start, this.end, null, "[]") ||
      this.start.isBetween(date.start, date.end, null, "[]")
    );
  }

  get isActive() {
    return moment(moment().format("DD-MM-YYYY"), "DD-MM-YYYY").isBetween(
      this.start,
      this.end,
      null,
      "[]"
    );
  }

  get startedFromNuw() {
    return this.start.fromNow();
  }

  get endingFromNow() {
    return this.end.fromNow();
  }

  get statusFromNow() {
    let full = this.end - this.start;
    let leftFromNow = this.end - moment.now();
    let percentage = (leftFromNow / full) * 100;
    return percentage <= 0
      ? "close"
      : percentage <= 10
      ? "warning-outline"
      : "check";
  }

  getActual(period) {
    if (!(period instanceof Period)) {
      return this.isActive ? this : null;
    }
    if (!this.isActive) {
      return period;
    }
    return this.date_end
      .split("-")
      .reverse()
      .join("-") <=
      period.date_end
        .split("-")
        .reverse()
        .join("-")
      ? this
      : period;
  }
}
